export const ActionTypes = {
    CHANGE_APP_STATE : "change_app_state",
}
